var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { NodesSummaryModel } from '../models/nodes-summary-model.interface';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AiTaggingRepository } from '../repositories/ai-tagging-repository.interface';
let NodeSummaryServiceImpl = class NodeSummaryServiceImpl {
    constructor(_nodesSummaryModel, _aiTaggingRepository) {
        this._nodesSummaryModel = _nodesSummaryModel;
        this._aiTaggingRepository = _aiTaggingRepository;
    }
    get nodeSummaryDataSet() {
        return this._nodesSummaryModel.nodeSummaryDataSet;
    }
    clearNodeSummaryDataSet() {
        this._nodesSummaryModel.clear();
    }
    updateNodeSummaryDataSet(nodeId, nodeSummary) {
        this._nodesSummaryModel.updateSummaryById(nodeId, nodeSummary);
    }
    updateNodeSummaryByNodeId(params) {
        return this._aiTaggingRepository.updateNodeSummaryByNodeId(params);
    }
    getSummaryById(nodeId) {
        return this._nodesSummaryModel.getSummaryById(nodeId);
    }
    reParsingNode(params) {
        return this._aiTaggingRepository.reParsingNode(params);
    }
    subscribeNodeSummary(callback) {
        return this._nodesSummaryModel.onStatesChange(callback);
    }
};
NodeSummaryServiceImpl = __decorate([
    injectable(),
    __param(0, inject(NodesSummaryModel)),
    __param(1, inject(AiTaggingRepository)),
    __metadata("design:paramtypes", [typeof (_a = typeof NodesSummaryModel !== "undefined" && NodesSummaryModel) === "function" ? _a : Object, typeof (_b = typeof AiTaggingRepository !== "undefined" && AiTaggingRepository) === "function" ? _b : Object])
], NodeSummaryServiceImpl);
export { NodeSummaryServiceImpl };
